const template = `
<div class="bottom-conditions">
	<form>
		<div class="conditions-container negative-trend">
			<h2>%winners-negative-trend-header%</h2>
			<div class="conditions-inner" data-name="winnersNegativeTrend">
				<div class="rows">

					<div class="row" data-sticky-template="bottom-conditions-winners-negative-trend-row">
					<label class="mr-20">%Min%
						<div class="styled-select">
							<select class="number-of-races min-points" name="minNegativeTrend"></select>
							<span class="sprite dropdown"></span>
						</div></label>
						<label class="mr-20">%max%
							<div class="styled-select">
								<select class="number-of-races max-points" name="maxNegativeTrend"></select>
								<span class="sprite dropdown"></span>
							</div> %with-negative-trend%</label>
					</div><!-- ROW -->
				</div>

			</div>
		</div><!-- CONTAINER -->

		<div class="conditions-container positive-trend">
			<h2>%winners-positive-trend-header%</h2>
			<div class="conditions-inner" data-name="winnersPositiveTrend">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-winners-positive-trend-row">
					<label class="mr-20">%Min%
						<div class="styled-select">
							<select class="number-of-races from-points" name="minPositiveTrend"></select>
							<span class="sprite dropdown"></span>
						</div></label>
						<label class="mr-20">%max%
							<div class="styled-select">
								<select class="number-of-races to-points" name="maxPositiveTrend"></select>
								<span class="sprite dropdown"></span>
							</div> %with-positive-trend%</label>
					</div><!-- ROW -->
				</div>
			</div>
		</div><!-- CONTAINER -->

		<div class="conditions-container winners-increased-percent">
			<h2>%winners-increased-percent-header%</h2>
			<div class="conditions-inner" data-name="winnersIncreasedPercent">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-winners-increased-percent-row">
					<div class="button delete">
						<div class="wrapper">
							<div class="align y x"><div><div class="base-blue"></div></div></div>
							<div class="align y x"><div class="content"><span class="sprite button-minus-small"></span></div></div>
						</div>
					</div>
					<label class="mr-20">%Min%
						<div class="styled-select">
							<select class="number-of-races from-points" name="winnersIncreasedPercent[%row%][min]"></select>
							<span class="sprite dropdown"></span>
						</div></label>
						<label class="mr-20">%max%
							<div class="styled-select">
								<select class="number-of-races to-points" name="winnersIncreasedPercent[%row%][max]"></select>
								<span class="sprite dropdown"></span>
							</div></label>
					<label>%with-increased% <input type="number" inputmode="numeric" class="percentage-point" name="winnersIncreasedPercent[%row%][percentagePoint]" min="-1" max="999"> %percent-point%</label>
					</div><!-- ROW -->
				</div>
				<div class="button plus">
					<div class="wrapper">
						<div class="align y x"><div><div class="base-blue"></div></div></div>
						<div class="align y x"><div class="content"><span class="sprite button-plus-small"></span></div></div>
					</div>
				</div>
			</div>
		</div><!-- CONTAINER -->

		<div class="conditions-container winners-decreased-percent">
			<h2>%winners-decreased-percent-header%</h2>
			<div class="conditions-inner" data-name="winnersDecreasedPercent">
				<div class="rows">
				<div class="row" data-sticky-template="bottom-conditions-winners-decreased-percent-row">
				<div class="button delete">
					<div class="wrapper">
						<div class="align y x"><div><div class="base-blue"></div></div></div>
						<div class="align y x"><div class="content"><span class="sprite button-minus-small"></span></div></div>
					</div>
				</div>
				<label class="mr-20">%Min%
					<div class="styled-select">
						<select class="number-of-races from-points" name="winnersDecreasedPercent[%row%][min]"></select>
						<span class="sprite dropdown"></span>
					</div></label>
					<label class="mr-20">%max%
						<div class="styled-select">
							<select class="number-of-races to-points" name="winnersDecreasedPercent[%row%][max]"></select>
							<span class="sprite dropdown"></span>
						</div></label>
				<label>%with-decreased%<input type="number" inputmode="numeric" class="percentage-point" name="winnersDecreasedPercent[%row%][percentagePoint]" min="-1" max="999"> %percent-point%</label>
					</div><!-- ROW -->
				</div>
				<div class="button plus">
					<div class="wrapper">
						<div class="align y x"><div><div class="base-blue"></div></div></div>
						<div class="align y x"><div class="content"><span class="sprite button-plus-small"></span></div></div>
					</div>
				</div>
			</div>
		</div><!-- CONTAINER -->

		<input type="submit" class="submit">
	</form>
</div>
`;

export default template;
